import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, ChevronRight } from "lucide-react";
import MeetingRecorder from "@/components/MeetingRecorder";
import CallImportButton from "@/components/CallImportButton";

export default function MeetingHubCard() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const btn = "flex-1 h-11 rounded-2xl text-sm font-semibold inline-flex items-center justify-center gap-2 transition-colors";
  return (
    <div className="col-span-2 klt-glow-card rounded-3xl p-5 klt-fade-up" data-testid="meeting-hub-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-heading text-lg font-extrabold">Réunion & appel</p>
          <p className="text-sm text-muted-foreground">Compte rendu IA sans limite de durée, mis au planning et sur les fiches</p>
        </div>
        <button onClick={() => navigate("/reunions")} data-testid="meeting-hub-list" className="text-xs font-semibold text-[#60A5FA] inline-flex items-center shrink-0">Comptes rendus <ChevronRight className="w-4 h-4" /></button>
      </div>
      <div className="flex gap-2 mt-4">
        <button onClick={() => setOpen(true)} data-testid="meeting-record-btn" className={`${btn} klt-fab-neon text-white`}><Users className="w-4 h-4" /> Réunion</button>
        <CallImportButton className={`${btn} bg-[#3B82F6]/15 text-[#60A5FA] hover:bg-[#3B82F6]/25`} label="Appel" />
      </div>
      {open && <MeetingRecorder onClose={() => setOpen(false)} />}
    </div>
  );
}
